import { render, staticRenderFns } from "./DocManage.vue?vue&type=template&id=462e3170&scoped=true&"
import script from "./DocManage.vue?vue&type=script&lang=js&"
export * from "./DocManage.vue?vue&type=script&lang=js&"
import style0 from "./DocManage.vue?vue&type=style&index=0&id=462e3170&scoped=true&lang=css&"
import style1 from "./DocManage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462e3170",
  null
  
)

export default component.exports